const HEX = {
  amber400: "#fbbf24",
  indigo400: "#818cf8",
  teal400: "#2dd4bf",
  rose400: "#fb7185",
  violet400: "#a78bfa",
  blue400: "#60a5fa",
  purple400: "#c084fc",
  emerald400: "#34d399",
  green400: "#4ade80",
  cyan400: "#22d3ee",
  sky400: "#38bdf8",
  lime400: "#a3e635",
  orange400: "#fb923c",
  yellow400: "#facc15",
  fuchsia400: "#e879f9",
  pink400: "#f472b6",
  red400: "#f87171",
  stone400: "#a8a29e",
  slate400: "#94a3b8",
  primary: "#3b82f6",
} as const;

export const DOMAIN_COLOR_HEX: Record<string, string> = {
  asset: HEX.amber400,
  supplier: HEX.amber400,
  policy: HEX.indigo400,
  document: HEX.teal400,
  evidence: HEX.teal400,
  risk: HEX.rose400,
  assurance: HEX.violet400,
  control: HEX.blue400,
  standard: HEX.purple400,
  checklist: HEX.emerald400,
  privacyrequest: HEX.cyan400,
  datatype: HEX.lime400,
  datastorage: HEX.sky400,
  legalobligation: HEX.orange400,
  issue: HEX.red400,
  interestedparty: HEX.fuchsia400,
  objective: HEX.green400,
  audit: HEX.yellow400,
  finding: HEX.pink400,
  correctiveaction: HEX.stone400,
  incident: HEX.orange400,
  other: HEX.slate400,
};

export function colorForDomain(input?: string): string {
  const key = String(input || "").toLowerCase();
  return DOMAIN_COLOR_HEX[key] || HEX.primary;
}
